<template>
    <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">{{ $t("app.modules.complaints.single") }} {{ $t("app.modules.complaints.headers.detail") }}</h4>
    <div class="row">
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.number_cliente") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.numeroCliente }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.bussiness_name") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.razonSocial }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.order_numbre") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.pedido }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.product") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.producto }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.product_description") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.textoBreveMaterial }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.batch") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.lote }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.invoice") }}/{{ $t("app.modules.complaints.headers.purchase_order") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.factura }}/{{ item.odc }}</small>
            </h5>
        </div>
    </div>
    <div class="row">
        <div :class="sizesfx">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.description") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.descripcion }}</small>
            </h5>
        </div>
    </div>
    <div class="row">
        <div :class="sizesfx">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.evidence") }}</b>
            </small>
            </h4>
              <template>
                <el-table
                  :data="evidencia"
                  style="width: 100%">
                  <el-table-column :label="$t('app.modules.complaints.headers.evidence')" width="500">
                    <div slot-scope="props">
                      <el-link :href=props.row.evidencia target="_blank">{{ splitEvidence(props.row.evidencia) }} <i class="el-icon-folder"></i></el-link>
                    </div>
                  </el-table-column>
                </el-table>
              </template>
        </div>
    </div>
    <div class="row">
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.registration_date") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.fechaRegistro }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.claimant_name") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.nombre }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.telephone") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.telefono }}</small>
            </h5>
        </div>
        <div :class="sizes">
            <h4>
            <small>
                <b>{{ $t("app.modules.complaints.headers.emai") }}</b>
            </small>
            </h4>
            <h5>
                <small>{{ item.email }}</small>
            </h5>
        </div>
    </div>
    <div
        slot="footer"
        style="margin-top: 10px; padding-top: 20px;border-top: outset;"
        class="text-right"
    >
    </div>
  </modal>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
export default {
  components: {},
  data() {
    return {
    sizes: "col-md-4 col-sm-12",
    sizesfx: "col-md-8 col-sm-12",
      item: {
        idTipoMoneda: 0,
        nombre: '',
        abreviatura: '',
        activo: true,
        idEmpresa: 0
      },
      payload: {
        idTipoMoneda: 0,
        nombre: '',
        abreviatura: '',
        activo: true,
        idEmpresa: 0
      },
      switches: {
        withIconsOn: true
      },
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      evidencia:[],
      modalEdit: false,
      modals: {
        classic: false
      },
    };
  },
  mounted() {
    EventBus.$on("reclamaciones-detail", async item => {
      console.log('Hola mundo');
      this.getEvidencia(item);
      this.item = item;
        this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });
      this.$swal.close();
      this.modals.classic = true;

    });
  },
  methods: {
    splitEvidence(pathString){
      var re = "";
      var cut = pathString.split('/');
      if(cut.length > 1){
        re = cut[cut.length - 1];
      }
      return re;
    },
    cancelEdit() {
      this.modalEdit = false;
      this.$refs.formEdit.reset();
    },
    async sendMail(id)
    {
        this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var payload = {id: id, estado: 0}
      await this.$http
        .post(route("Reclamaciones/postAcuseRecibidoReclamacion"), payload)
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.modals.classic = false;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    },
     async getEvidencia(row) {
        this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var payload = {id: row.idReclamacion, estado: this.typeSelected}
      await this.$http
        .post(route("Reclamaciones/getReclamacionesEvidencia"), payload)
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.evidencia = response.body.evidenciaReclamacion;
              console.log(this.evidencia);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 10px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
.modal-dialog {
    max-width: 1000px !important;
    margin: 1.75rem auto;
}
</style>
